/*  ========================================================================
    # Section - Hero Full
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import ProductionCard from '../../components/ProductionCard';

const ProductionCards = ({ title, hideSegments, productions }) => {
  return (
    <div className={`c-production-cards__wrapper`}>
      <div className='container'>
        <div className='row'>
          {title && (
            <div className='col-full'>
              <h2>{title}</h2>
            </div>
          )}
          {productions.map((production, index) => (
            <div className='col-full md:col-6/12 xl:col-4/12' key={index}>
              <ProductionCard
                hideSegment={hideSegments}
                image={production.image}
                title={production.title}
                segment={production.segment}
                description={production.description}
                url={production.url}
                nextDate={production.nextDate}
                subtitle={production.subtitle}
                video={production.video}
              ></ProductionCard>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ProductionCards.propTypes = {
  title: PropTypes.string,
  hideSegments: PropTypes.bool,
  productions: PropTypes.array
};

export default ProductionCards;
